import React from 'react';
import { Input, Select, Button, Row, Col, Radio, Checkbox, DatePicker, Icon } from 'antd';
import SelectPlaceHolder from '../../../components/SelectPlaceHolder';
import moment from 'moment';
const { Option } = Select;
const InputGroup = Input.Group;
class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>

                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.referencia}
                            onChange={(e) => this.props.onChange("referencia", e.target.value)}
                            placeholder="Filtrar por codigo referencia"
                            autoComplete="off"
                        />
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={8}>
                        <InputGroup compact>
                            <Select showSearch labelInValue
                                value={this.props.filter.idProducto ? { key: this.props.filter.idProducto } : undefined}
                                style={{ width: `calc(100% - 40px)` }}
                                placeholder={"Búsqueda de Productos"}
                                optionFilterProp="children"
                                showArrow={false}
                                onSearch={this.props.onSearchAutocomplete}
                                onChange={this.props.onChangeAutocomplete}
                            >
                                {this.props.productos.map(item => (
                                    <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                ))}
                            </Select>
                            <Button
                                className="btn-autocomplete"
                                style={{ width: '40px', fontSize: '14px' }}
                                icon={this.props.filter.idProducto ? 'close' : 'search'}
                                onClick={this.props.onClearAutocomplete}
                            />
                        </InputGroup>
                    </Col>


                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.lote}
                            onChange={(e) => this.props.onChange("lote", e.target.value)}
                            placeholder="Filtrar por lote"
                            autoComplete="off"
                        />
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={3} hidden>
                        <DatePicker
                            placeholder="Filtrar por fecha inicio"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaInicioStr', value)}
                        />
                    </Col>
      
                    <Col className="gutter-row" sm={24} md={12} lg={4} >
                        <Select
                            showSearch labelInValue
                            value={this.props.filter.estado ? { key: this.props.filter.estado } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por estado" />}
                            onChange={(option) => this.props.onChange("estado", option.key)}
                            optionFilterProp="children"
                        >
                            <Select.Option value="0" key="0">TODOS</Select.Option>
                            {this.props.estados.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Filters;